<span>{{$text()}}</span> <i class="fa-solid fa-fw" [ngClass]="ngClassIcon()"></i>
